import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { FaCheckCircle, FaArrowLeft } from 'react-icons/fa';
import { getPaymentResult } from '../../api/paymentService';
import '../../styles/pages/paymentResult.scss';

const PaymentSuccess = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [paymentData, setPaymentData] = useState(null);
    const [error, setError] = useState(null);
    const isInIframe = (() => {
        try {
            return window.self !== window.top;
        } catch (err) {
            return true;
        }
    })();
    const parentOrigin = (() => {
        try {
            return new URL(document.referrer).origin;
        } catch (err) {
            return window.location.origin;
        }
    })();

    useEffect(() => {
        const fetchPaymentResult = async () => {
            const transactionId = searchParams.get('transactionId');

            if (isInIframe) {
                window.parent.postMessage({
                    type: 'PAYMENT_RESULT',
                    status: 'success',
                    transactionId
                }, parentOrigin);
                return;
            }

            if (!transactionId) {
                setError('İşlem numarası bulunamadı');
                setLoading(false);
                return;
            }

            try {
                const result = await getPaymentResult(transactionId);

                if (result.isSuccess && result.data) {
                    setPaymentData(result.data);
                } else {
                    setError(result.resultMessage || 'Ödeme bilgileri alınamadı');
                }
            } catch (err) {
                setError('Bir hata oluştu');
            } finally {
                setLoading(false);
            }
        };

        fetchPaymentResult();
    }, [searchParams, isInIframe]);

    if (isInIframe) {
        return null;
    }

    if (loading) {
        return (
            <div className="payment-result-container">
                <div className="payment-result-card">
                    <div className="loading-spinner"></div>
                    <p>Ödeme bilgileri yükleniyor...</p>
                </div>
            </div>
        );
    }

    if (error || !paymentData) {
        return (
            <div className="payment-result-container">
                <div className="payment-result-card error">
                    <h2>Hata</h2>
                    <p>{error || 'Ödeme bilgileri alınamadı'}</p>
                    <button className="back-button" onClick={() => navigate('/spor-randevu')}>
                        <FaArrowLeft /> Ana Sayfaya Dön
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div className="payment-result-container">
            <div className="payment-result-card success">
                <div className="success-icon">
                    <FaCheckCircle />
                </div>
                <h1>Ödeme Başarılı!</h1>
                <p className="success-message">{paymentData.message}</p>

                {paymentData.appointmentId && (
                    <div className="appointment-info">
                        <p><strong>Randevu Numaranız:</strong> {paymentData.appointmentId}</p>
                        <p className="info-text">
                            Randevu detaylarınız e-posta adresinize gönderilmiştir.
                        </p>
                    </div>
                )}

                <div className="transaction-info">
                    <p className="transaction-id">İşlem No: {paymentData.transactionId}</p>
                </div>

                <button className="back-button" onClick={() => navigate('/spor-randevu')}>
                    <FaArrowLeft /> Ana Sayfaya Dön
                </button>
            </div>
        </div>
    );
};

export default PaymentSuccess;
